import React, {Button, Component, useState } from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import LoadingOverlay from 'react-loading-overlay';
import _ from '../../utils/languages/languages';
import GetIntermediariesService from '../../services/getIntermediaries';
import GetAnalystsService from '../../services/getAnalysts';
import Table from '../../widgets/tables/AnalystTable';
import ManageInvestor from '../../services/manageInvestor';
import SendMail from '../../services/sendMail';
import GetEvent from '../../services/getEvent';
import CreateDirectory from '../../services/createDirectory';
import GetMeetings from '../../services/getMeetings';
import GetBreaks from '../../services/getBreaks';
import ZipFolder from '../../services/zipFolder';
import Constants from "../../utils/consts";
import WaitDialog from '../../widgets/WaitDialog';
import SendMailWidget from '../../widgets/SendMailWidget';
import moment from 'moment';
import PdfInvestors from '../../utils/pdf/investorScheduleJSON';
import Utils from '../../utils/utils';
import GetIntermediaryByUsername from '../../services/getIntermediaryByUsername';

const endLine = '\n';

export default class Investors extends React.Component {

  constructor(props){
    super (props)
  
    this.pageDiv = {
      border: '1px solid #cccccc',
      padding: 10
    };
  
    this.section = this.props.section
    if (this.section == undefined){
      const pathname = props.location.pathname;
      this.section = pathname.substring(8, pathname.length);
    }

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    if (this.pageName == undefined){
      this.pageName = this.section;
    }

    this.options = [
      { value: 'All', label: 'All' }
    ]

    this.eventslist = [];
    this.selectRef = React.createRef();

    this.state = {
      testo: '',
      menuBackground: '#ffffff',
      menuItemColor: '#000000',
      fontSize: 50,
      fontBold: false,
      logoPicture: '',
      logoMargin: 0,
      titleColor: '#000000',
      titleSize: 18,
      isLoading: false,
      addElementVisible: false
    }

    this.grid = 2;

    this.analystsList = [];
    this.pageTitle = "Investors";
    this.brokerId = undefined;
    this.elementPdf = undefined;

    const cookies = new Cookies();
    var strJson = JSON.stringify({list: []});
    cookies.set('checksList', strJson, { path: '/' });

    this.state = {
      waitDialogVisible: false,
      sendMailVisible: false
    };

  }

  async reload(){
    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });

    this.broker = await GetIntermediaryByUsername(username, token);
    this.brokerId = this.broker.id;
    
    const currentEventId = this.broker.event_id;
    this.event = await GetEvent(username, token, currentEventId);
    this.meetings = await GetMeetings(username, token, currentEventId);
    this.breaks = await GetBreaks(username, token, currentEventId);
    this.intermediaries = await GetIntermediariesService(username, token, currentEventId, 'investor');
    this.options = [{value: 'All', label: 'All', id: undefined}];
    this.intermediaries.map((v) => {
      this.options.push({value: v.name, label: v.name, id: v.id});
    });

    var broker = '';
    if (this.brokerId != undefined) {
      broker = this.brokerId;
    }
    this.analystsList = await GetAnalystsService(username, token, currentEventId, broker);

    this.analystsList.forEach(investor => {
      var meetings = this.meetings.filter(m => { 
        var found = false;
        m.investors.forEach(i => {
          if (i.id == investor.id) {found = true}
        });
        return found;
      });

      let sortMeetings = meetings.sort((a, b) => {
        var time1 = moment(a.date + " " + a.hour+":"+a.minutes, "DD/MM/yyyy HH:mm");
        var time2 = moment(b.date + " " + b.hour+":"+b.minutes, "DD/MM/yyyy HH:mm");

        return time1 - time2;
      });

      sortMeetings.forEach((a, index) => {
        if (index + 1 >= sortMeetings.length) return;
        var b = sortMeetings[index + 1];
        var time1 = moment(a.date + " " + a.hour+":"+a.minutes, "DD/MM/yyyy HH:mm");
        var time2 = moment(b.date + " " + b.hour+":"+b.minutes, "DD/MM/yyyy HH:mm");
        time1 = time1.add(a.slots * 5, 'minutes');
        if (time1 > time2){
          console.log('------------------------');
          console.log(investor.company + ' ' + investor.name);
          console.log(a.date + ' ' + a.hour+":"+a.minutes);
          console.log(b.date + ' ' + b.hour+":"+b.minutes);
          alert ('ALARM: ' + investor.company + ' ' + investor.name + a.date + ' ' + a.hour+":"+a.minutes + b.date + ' ' + b.hour+":"+b.minutes + ' ' + a.id + ' ' + b.id);

        }

      });

    })


    this.setState({});
  }

  async componentDidMount(){
    await this.reload();

  }

  async onChange(value) {
    this.brokerId = value.id;
    await this.reload();
  }

  async savePdfIndex(dirName){
    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });

    var index = 0;
    while (index < this.analystsList.length){
      var investor = this.analystsList[index];

      var json = cookies.get('checksList', { path: '/' });
      var checksList = json.list;
      if (checksList.length > 0){
        if (checksList.indexOf(investor.id) == -1){
          index++;
          continue;
        }
      }

      this.pdfUrl = await PdfInvestors.getAddress(this.event, investor, this.breaks, this.meetings, dirName);
      this.setState({
        waitDialogVisible: true,
        index: index + '/' + (checksList.length > 0 ? checksList.length : this.analystsList.length)
      });
      index++;

    }
    await ZipFolder(username, token, dirName);
    window.location.href= Constants.mainUrl+'fixmeeting-pdfs/storage/app/public/pdf/'+dirName+'pdfs.zip';
    this.setState({waitDialogVisible: false});
  }

  render () {

    const defaultFontValue = {
      fontFamily: 'Montserrat',
      fontSize: 21,
      color: '#555555'
    }

    var headCells = [
      { id: 'company', numeric: false, disablePadding: true, label: 'Investment company' },
      { id: 'name', numeric: false, disablePadding: true, label: 'Analyst name' },
      { id: 'brokerName', numeric: false, disablePadding: true, label: 'Intermediary' },
      { id: 'country', numeric: true, disablePadding: false, label: 'Country' },
      { id: 'phone_number', numeric: true, disablePadding: false, label: 'Phone number' },
      { id: 'email_address', numeric: true, disablePadding: false, label: 'Email' },
    ];

    function createData(name, website, country, phone_number, mobile_number) {
      return { name, website, country, phone_number, mobile_number};
    }

    var rows = [];
    this.eventslist.length > 0 && this.eventslist.map((v, k) => {
      rows.push(createData(v.name, v.website, v.username));
    });

    const cookies = new Cookies();
    const currentEventName = cookies.get('currentEventName', { path: '/' });

    return (
      <>
      <LoadingOverlay
      active={this.state.isLoading}
      styles={{
        content: (base) => ({
          position: 'relative',
          width: '100%',
          top: '200px'
        })
      }}
      spinner
      text={_.tr('Loading your content...')}
      >
        <PageTitle title="Analysts" secondButton="PRINT ALL PDF" thirdButton="PRINT PDF SINGLE FILE" 
        
        onClick={() => {
          if (this.brokerId == undefined) {
            alert ("Please select an intermediary first");
            return;
          }

          const cookies = new Cookies();
          cookies.set('currentBroker', this.brokerId, { path: '/' });
          window.location.href = '/#/app/addanalyst';

        }}

        onSecondClick={async () => {

          const cookies = new Cookies();
          const username = cookies.get('username', { path: '/' });
          const token = cookies.get('token', { path: '/' });
          const dirName = await CreateDirectory(username, token) + '/';
         
          this.savePdfIndex(dirName);
        }}

        onThirdClick={async () => {

          cookies.set('pdfStartDate', this.event.startDate, { path: '/' });
          cookies.set('pdfEndDate', this.event.endDate, { path: '/' });
          cookies.set('scheduleType', 'allAnalysts', { path: '/' });
          cookies.set('brokerId', this.brokerId, { path: '/' });
          window.location.href= '#/app/pdfPage';
        }}

        onFourthClick={async () => {

          var json = cookies.get('checksList', { path: '/' });
          var checksList = json.list;

          var mailList = this.analystsList;
          if (checksList.length > 0){
            mailList = mailList.filter(m => { return checksList.indexOf(m.id) != -1 });            
          }

          this.setState({
            sendMailVisible: true,
            mailCompaniesList: mailList
          });
        }}

        />

        <Table headCells={headCells} broker={true}  rows={this.analystsList} onEventClick={(row) => {
          cookies.set('currentInvestor', row, { path: '/' });
          window.location.href = '/#/app/editanalyst';
        }}

        onSendMail= {async (analystId) => {
          this.setState({
            sendMailVisible: true,
            mailAddressList: this.analystsList.filter((elem) => elem.id == analystId)
          });
        }}

        onDelete={async (investorId) => {
          if (window.confirm("Delete the analyst?")) {

            const cookies = new Cookies();
            const username = cookies.get('username', { path: '/' });
            const token = cookies.get('token', { path: '/' });
      
            let res = await ManageInvestor (username, token, investorId, 0, 0, 
              '', '', '', '', '', '', 
              '', '', '', true, 1);

            if (res.result != 'ok'){
              alert ('An error occurred while deleting the company.')
            } else {
              this.reload();            
            }
          }
        }}
        
        onElementCheck={async (companyId) => {
          const cookies = new Cookies();

          var json = cookies.get('checksList', { path: '/' });
          var checksList = json.list;
          var index = checksList.indexOf(companyId);
          if (index != -1)
            checksList.splice(index, 1);
          else 
            checksList.push(companyId);

          cookies.set('checksList', JSON.stringify({list: checksList}), { path: '/' });
        }}

        />
        {this.elementPdf ? this.elementPdf : null}
        
        {false && <SendMailWidget 
          show={this.state.sendMailVisible} 
          onClose={() => this.setState({sendMailVisible: false})}
          onSend={async (subject, body) => {
            var numProcessed = 0;
            var numErrors = 0;
            var messageLog = "";

            if (this.event.mailUser == '' || this.event.mailPassword == ''){
              alert ('You have to specify an address and a password in Event Details');
              return;
            }

            this.setState({waitDialogVisible: true, index:  numProcessed + '/' + this.state.mailAddressList.length})

            for (const analyst of this.state.mailAddressList) {

              if (analyst.email_address == undefined || analyst.email_address == "") {
                messageLog += analyst.name + ' NO MAIL DEFINED' + endLine;
                numProcessed++;
                numErrors++;

                this.setState({waitDialogVisible: true, index:  numProcessed + '/' + this.state.mailAddressList.length})
                continue;
              }

         /*    var from = "conference@cnroadshows.com";
              var fromName = "Conference";
              var password = "Povera_Matilde1"; */

              var from = this.event.mailUser;
              var fromName = this.event.mailUser;
              var password = this.event.mailPassword;

              var to = analyst.email_address.trim();
              var cc = analyst.second_email_address.trim();
              var bcc = from.trim();
              var toName = analyst.name;
  
              try {
                var attachmentPath = (await Utils.getPdfUrl('investor', analyst.id)).replace('http://fixmeeting.eu/', '');
                await SendMail('', '', from, fromName, password, to, '', cc, bcc, toName, attachmentPath, subject, body);
                //messageLog += analyst.name + ' ' + to + ' SENT' + endLine;

              } catch (error){
                numErrors++;
                messageLog += analyst.name + ' ' + to + ' ERROR' + endLine;
              }

              numProcessed++;
              this.setState({waitDialogVisible: true, index:  numProcessed + '/' + this.state.mailAddressList.length})

          }
          this.setState({waitDialogVisible: false})
          this.setState({sendMailVisible: false})

          alert ('ERRORS: ' + numErrors  + endLine + messageLog);
        }}

        
          /> }
        <WaitDialog show={this.state.waitDialogVisible} index={this.state.index} key={Math.random()}/>

        </LoadingOverlay>
      </>
    );
  }

}

